import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import "./ViewAdminUsers.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const ViewAdminUsers = () => {
  // const [userType, setUserType] = useState("engineer");
  const [rows, setRows] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const [userType, setUserType] = useState("all");

  useEffect(() => {
  if (userType === "engineer") {
    fetchEngineers();
  } else if (userType === "supervisor") {
    fetchSupervisors();
  } else {
    fetchAllUsers(); // ✅ NEW
  }
}, [userType]);



const fetchAllUsers = async () => {
  try {
    const [engRes, supRes] = await Promise.all([
      axios({
        url: `${API_URL}/api/get_engineers_by_customer_admin/${customerId}/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
           "X-User-Type": "A",   // ✅ ADD THIS
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data:{},
      }),
      axios({
        url: `${API_URL}/api/get_supervisors_by_customer_admin/${customerId}/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
           "X-User-Type": "A",   // ✅ ADD THIS
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data:{},
      }),
    ]);

    // ✅ Engineers
    const engineers = engRes.data.engineers.map((eng) => ({
      id: eng.id.id,
      first_name: eng.firstName,
      last_name: eng.lastName,
      email: eng.email,
      phone_no: eng.phone,
      role: "Site Engineer",
      site_name:
        Array.isArray(eng.assigned_sites) && eng.assigned_sites.length > 0
          ? eng.assigned_sites.join(", ")
          : "N/A",
    }));

    // ✅ Supervisors
    const supervisors = supRes.data.supervisors.map((sup) => ({
      id: sup.id.id,
      first_name: sup.firstName,
      last_name: sup.lastName,
      email: sup.email,
      phone_no: sup.phone || "N/A",
      role: "Supervisor",
      site_name:
        Array.isArray(sup.assigned_sites) && sup.assigned_sites.length > 0
          ? sup.assigned_sites.join(", ")
          : "N/A",
    }));

    // ✅ Merge both
    setRows([...engineers, ...supervisors]);
    setPage(0);

  } catch (error) {
    console.error("Error fetching all users:", error);
    setRows([]);
  }
};




  // 🔹 Fetch Engineers
  const fetchEngineers = async () => {
    try {
      const response = await axios({
        url: `${API_URL}/api/get_engineers_by_customer_admin/${customerId}/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
           "X-User-Type": "A",   // ✅ ADD THIS
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      });

      const data = response.data.engineers.map((eng) => ({
        id: eng.id.id,
        first_name: eng.firstName,
        last_name: eng.lastName,
        email: eng.email,
        phone_no: eng.phone,
        role: "Site Engineer",
        site_name:
    Array.isArray(eng.assigned_sites) && eng.assigned_sites.length > 0
      ? eng.assigned_sites.join(", ")
      : "N/A",
      }));

      setRows(data);
      setPage(0);
    } catch (error) {
      console.error("Error fetching engineers:", error);
      setRows([]);
    }
  };

  // 🔹 Fetch Supervisors
  const fetchSupervisors = async () => {
    try {
      const response = await axios({
        url: `${API_URL}/api/get_supervisors_by_customer_admin/${customerId}/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
           "X-User-Type": "A",   // ✅ ADD THIS
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      });

      const data = response.data.supervisors.map((sup) => ({
        id: sup.id.id,
        first_name: sup.firstName,
        last_name: sup.lastName,
        email: sup.email,
        phone_no: sup.phone || "N/A",
        role: "Supervisor",
        site_name:
    Array.isArray(sup.assigned_sites) && sup.assigned_sites.length > 0
      ? sup.assigned_sites.join(", ")
      : "N/A",
      }));

      setRows(data);
      setPage(0);
    } catch (error) {
      console.error("Error fetching supervisors:", error);
      setRows([]);
    }
  };

  return (
    <Box className="view-users-container">
      
      {/* 🔹 Dropdown */}
      <FormControl fullWidth sx={{width:300, mb: 3 }}>
        <InputLabel>Select User Type</InputLabel>
        <Select
          value={userType}
          label="Select User Type"
          onChange={(e) => setUserType(e.target.value)}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="engineer">Site Engineer</MenuItem>
          <MenuItem value="supervisor">Supervisor</MenuItem>
        </Select>
      </FormControl>

      {/* 🔹 Table */}
      <TableContainer component={Paper} className="users-table-wrapper">
        <Table
  stickyHeader
  sx={{
    "& .MuiTableCell-root": {
      fontSize: 13,
      color: "#1e293b",
      borderBottom: "1px solid #e2e8f0",
    },
  }}
>
          <TableHead>
  <TableRow>
    {[
      "Sr No",
      "First Name",
      "Last Name",
      "Email",
      "Phone",
      "Role",
      "Assigned Site",
    ].map((text) => (
      <TableCell
        key={text}
        sx={{
          background:
            "linear-gradient(to bottom, #EE7F1A 0%, #f2b14b 55%, #eea53a 100%)",
          color: "#fff",
          fontWeight: "bold",
          fontSize: 13,
        }}
      >
        {text}
      </TableCell>
    ))}
  </TableRow>
</TableHead>

          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{row.first_name}</TableCell>
                  <TableCell>{row.last_name}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.phone_no}</TableCell>
                  <TableCell>{row.role}</TableCell>
                   <TableCell>
                          <Box className="site-badge">{row.site_name}</Box>
                    </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {/* 🔹 Pagination */}
        {rows.length > 0 && (
          <div className="pagination-bar">
            <div className="rows-select">
              Rows per page:
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
              </select>
            </div>

            <div className="page-info">
              {page * rowsPerPage + 1}-
              {Math.min((page + 1) * rowsPerPage, rows.length)} of{" "}
              {rows.length}
            </div>

            <div className="page-arrows">
              <button disabled={page === 0} onClick={() => setPage(page - 1)}>
                ‹
              </button>
              <button
                disabled={(page + 1) * rowsPerPage >= rows.length}
                onClick={() => setPage(page + 1)}
              >
                ›
              </button>
            </div>
          </div>
        )}
      </TableContainer>
    </Box>
  );
};

export default ViewAdminUsers;